import { supportedStores } from './stores.js';
const imageDomains = {
    'x-kom': ['x-kom.pl', 'x-kom.com', 'x-kom.com.pl'], morele: ['morele.net'],
    'media-expert': ['mediaexpert.pl', 'inspiredigital.pl'], 'rtv-euro-agd': ['euro.com.pl', 'euro.com'],
    komputronik: ['komputronik.pl'], 'amazon-pl': ['amazon.pl', 'media-amazon.com', 'ssl-images-amazon.com'],
};
export function detectStore(raw) {
    try {
        const url = new URL(raw);
        if (url.protocol !== 'https:' || url.username || url.password || (url.port && url.port !== '443'))
            return null;
        return supportedStores.find(store => [store.domain, 'www.' + store.domain].includes(url.hostname.toLowerCase())) ?? null;
    }
    catch {
        return null;
    }
}
export function safeStoreImage(raw, base) {
    const store = detectStore(base);
    if (!store || typeof raw !== 'string' || raw.length > 2048)
        return null;
    try {
        const url = new URL(raw, base);
        if (url.protocol !== 'https:' || url.username || url.password || (url.port && url.port !== '443'))
            return null;
        return imageDomains[store.key].some(domain => url.hostname === domain || url.hostname.endsWith('.' + domain)) ? url.href : null;
    }
    catch {
        return null;
    }
}
